import { SET_TopicTree, SET_TopicList, SET_KeywordList, SET_TopicTreeLearning, SET_TopicListLearning, SET_KeywordListLearning, SET_TopicTreeTest, SET_TopicListTest, SET_LearningContents, SET_MockTest, SET_ContentLimit } from "./data.types";

export function setTopicTree(data) {
  return {
    type: SET_TopicTree,
    data,
  }
}

export function setTopicList(data) {
  return {
    type: SET_TopicList,
    data,
  }
}

export function setKeywordList(data) {
  return {
    type: SET_KeywordList,
    data,
  }
}

export function setTopicTreeLearning(data) {
  return {
    type: SET_TopicTreeLearning,
    data,
  }
}

export function setTopicListLearning(data) {
  return {
    type: SET_TopicListLearning,
    data,
  }
}

export function setKeywordListLearning(data) {
  return {
    type: SET_KeywordListLearning,
    data,
  }
}

export function setTopicTreeTest(data) {
  return {
    type: SET_TopicTreeTest,
    data,
  }
}

export function setTopicListTest(data) {
  return {
    type: SET_TopicListTest,
    data,
  }
}

export function setLearningContents(data) {
  return {
    type: SET_LearningContents,
    data,
  }
}

export function setMockTest(data) {
  return {
    type: SET_MockTest,
    data,
  }
}

export function setContentLimit(data) {
  return {
    type: SET_ContentLimit,
    data,
  }
}